import { v4 as uuid } from 'uuid';
import { Button } from 'antd';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';
import { useEffect, useState } from 'react';
import {
  PlacesAutoComplete,
  ZorbaInput,
} from '../../../../../components/forms';
import { DEFAULT_BUYBOX_PARAMS } from '../../../../../pages/BuyBoxPage/constants';

import './index.scss';

export default (props) => {
  const { validationObj } = props;
  const [createdBuyboxes, setCreatedBuyboxes] = useState([
    {
      ...DEFAULT_BUYBOX_PARAMS,
      id: uuid(),
    },
  ]);

  const onPlacesChange = (address, buyboxIndex) => {
    if (!address?.formattedAddress) return;
    setCreatedBuyboxes((prevBuyboxes) =>
      prevBuyboxes.map((buybox, index) => {
        if (index !== buyboxIndex) return buybox;

        return {
          ...buybox,
          areas: [address],
          title: address.formattedAddress.split(',')[0],
        };
      }),
    );
  };

  const handleAddBuybox = () => {
    setCreatedBuyboxes([
      ...createdBuyboxes,
      { ...DEFAULT_BUYBOX_PARAMS, id: uuid() },
    ]);
  };
  const handleDeleteBuybox = (id) => {
    const updatedBuyboxes = createdBuyboxes.filter((b) => b.id !== id);
    setCreatedBuyboxes(updatedBuyboxes);
  };

  const handleOnInputChange = (value, key, buyboxIndex, keyIndex) => {
    setCreatedBuyboxes((prevBuyboxes) =>
      prevBuyboxes.map((buybox, index) => {
        if (index !== buyboxIndex) return buybox;

        return {
          ...buybox,
          [key]: buybox[key].map((item, i) => (i === keyIndex ? value : item)),
        };
      }),
    );
  };

  const isCreatedNewBuyboxDisabled = !createdBuyboxes.every(
    (createdBuybox) =>
      createdBuybox.areas.length > 0 &&
      createdBuybox.priceRange[1] &&
      createdBuybox.yearBuiltRange[0],
  );

  useEffect(() => {
    props.onChange('buyBoxList', createdBuyboxes);
  }, [createdBuyboxes]);

  return (
    <div className="onboarding-step buybox">
      <h2>{`Now let's set your buy box criteria`}</h2>
      {createdBuyboxes.map((buybox, idx) => (
        <div className="onboarding-buybox-container" key={buybox.id}>
          <div className="title-container">
            <h2>Select your market</h2>
            {idx > 0 && (
              <FaTrash
                className="trash-icon"
                onClick={() => handleDeleteBuybox(buybox.id)}
              />
            )}
          </div>
          <PlacesAutoComplete
            className="area-list-auto-complete-onboarding"
            title={` `}
            onChange={(address) => onPlacesChange(address, idx)}
            label="Select your market"
            clearInputOnSelect={false}
            clearInputOnBlur={false}
            fullWidth
            showOnlyLocalitiesAndZipCodes
          />
          {buybox.areas.length > 0 && (
            <div className="input-container">
              <ZorbaInput
                type="number"
                minValue={0}
                value={buybox.priceRange[1]}
                fullWidth={false}
                label="Max purchase price"
                symbol="$"
                onChange={(e) => handleOnInputChange(e, 'priceRange', idx, 1)}
              />
              <ZorbaInput
                type="number"
                symbol=""
                minValue={0}
                maxValue={new Date().getFullYear()}
                disableFormatter
                value={buybox.yearBuiltRange[0]}
                fullWidth={false}
                label="Min year built"
                onChange={(e) =>
                  handleOnInputChange(e, 'yearBuiltRange', idx, 0)
                }
              />
            </div>
          )}
        </div>
      ))}
      <Button
        type="dashed"
        onClick={handleAddBuybox}
        style={{ marginTop: 8 }}
        disabled={isCreatedNewBuyboxDisabled}
      >
        Add another market
      </Button>
      {validationObj.buyBoxList && (
        <span
          style={{
            marginTop: '10px',
            color: 'red',
            display: 'inline-block',
          }}
        >
          {validationObj.buyBoxList}
        </span>
      )}
    </div>
  );
};
